<div class="d-flex align-items-center" mat-dialog-title>
    <div class="spacer title">Adressen</div>

    <div>
        <button mat-dialog-close mat-icon-button tabindex="-1">
            <i class="fas fa-times"></i>
        </button>
    </div>
</div>

<mat-dialog-content>
    <div class="row">
        <div class="col-10">
            <mat-list>
                <div
                    class="pb-0 pt-0 curpoint"
                    [class.active]="selectedField === SelectedField.origin"
                    (click)="selectedField = SelectedField.origin"
                    mat-subheader
                    matRipple>
                    Start
                </div>

                <mat-list-item
                    class="curpoint d-flex"
                    [class.active]="selectedField === SelectedField.origin"
                    (click)="selectedField = SelectedField.origin"
                    matRipple>
                    @if (originFromPreviousWork) {
                        <i class="fa-regular fa-road-barrier me-2" mat-list-icon></i>
                    } @else {
                        <app-address-icon
                            class="me-2"
                            [location]="location"
                            [address]="form.value.origin"
                            [userId]="user.id"
                            [users]="[user]"
                            mat-list-icon />
                    }

                    <div mat-line>
                        {{ form.value.origin | split }}<br />
                        <small>{{ form.value.origin | split: 1 }}</small>
                    </div>
                </mat-list-item>

                <mat-divider></mat-divider>

                <div
                    class="pb-1 pt-1 curpoint"
                    [class.active]="selectedField === SelectedField.work"
                    (click)="selectedField = SelectedField.work"
                    mat-subheader
                    matRipple>
                    Werklocatie
                </div>

                <mat-list-item
                    class="curpoint"
                    [class.active]="selectedField === SelectedField.work || selectedField === SelectedField.work_begin"
                    (click)="selectedField = SelectedField.work_begin"
                    matRipple>
                    <app-address-icon
                        class="me-2"
                        [address]="form.value.work_begin"
                        [location]="location"
                        [userId]="user.id"
                        [users]="[user]"
                        mat-list-icon />

                    <div mat-line>
                        {{ form.value.work_begin | split }}<br />
                        <small>{{ form.value.work_begin | split: 1 }}</small>
                    </div>
                </mat-list-item>

                <mat-list-item
                    class="curpoint"
                    [class.active]="selectedField === SelectedField.work || selectedField === SelectedField.work_end"
                    (click)="selectedField = SelectedField.work_end"
                    matRipple>
                    <app-address-icon
                        class="me-2"
                        [address]="form.value.work_end"
                        [location]="location"
                        [userId]="user.id"
                        [users]="[user]"
                        mat-list-icon />
                    <div mat-line>
                        {{ form.value.work_end | split }}<br />
                        <small>{{ form.value.work_end | split: 1 }}</small>
                    </div>
                </mat-list-item>

                <mat-divider></mat-divider>

                <div
                    class="pb-0 pt-0 curpoint"
                    [class.active]="selectedField === SelectedField.destination"
                    (click)="selectedField = SelectedField.destination"
                    mat-subheader
                    matRipple>
                    Einde
                </div>

                <mat-list-item
                    class="curpoint"
                    [class.active]="selectedField === SelectedField.destination"
                    (click)="selectedField = SelectedField.destination"
                    matRipple>
                    <app-address-icon
                        class="me-2"
                        [address]="form.value.destination"
                        [location]="location"
                        [userId]="user.id"
                        [users]="[user]"
                        mat-list-icon />

                    <div mat-line>
                        {{ form.value.destination | split }}<br />
                        <small>{{ form.value.destination | split: 1 }}</small>
                    </div>
                </mat-list-item>
            </mat-list>
        </div>

        <div class="col-14">
            <mat-form-field class="w-100" appearance="fill">
                <mat-label>Zoeken</mat-label>

                <input [formControl]="search" matInput placeholder="Zoeken" type="text" autocomplete="off" />

                <mat-error></mat-error>
            </mat-form-field>

            <mat-action-list>
                @let userAddress =
                    {
                        street: user.street,
                        housenumber: user.housenumber,
                        zipcode: user.zipcode,
                        town: user.town,
                    };

                @if (isAddress(userAddress)) {
                    <div class="p-2 curpoint" (click)="choose(userAddress)" mat-list-item matRipple>
                        <div class="row">
                            <div class="col-auto d-flex align-items-center pr-0">
                                <i class="fa-duotone fa-house-user"></i>
                            </div>

                            <div class="col">
                                {{ user.street }} {{ user.housenumber }}<br />
                                {{ user.zipcode }} {{ user.town }}
                            </div>
                        </div>
                    </div>
                }

                <div class="p-2 curpoint" (click)="choose(companyAddress)" mat-list-item matRipple>
                    <div class="row">
                        <div class="col-auto d-flex align-items-center pr-0">
                            <img class="dvds-icon" src="/assets/images/logo-small.png" />
                        </div>

                        <div class="col">
                            {{ companyAddress.street }} {{ companyAddress.housenumber }}<br />
                            {{ companyAddress.zipcode }} {{ companyAddress.town }}
                        </div>
                    </div>
                </div>

                @for (address of addresses; track address) {
                    <div class="p-2 curpoint" (click)="choose(address)" mat-list-item matRipple>
                        <div class="row">
                            <div class="col-auto d-flex align-items-center pr-0">
                                <i class="fa-duotone fa-hotel"></i>
                            </div>

                            <div class="col">
                                {{ address }}
                            </div>
                        </div>
                    </div>
                }
            </mat-action-list>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="justify-content-between">
    <button class="me-2" id="close-empl" (click)="close()" color="secondary" mat-raised-button>Sluiten</button>

    <button (click)="save()" color="primary" mat-raised-button>Opslaan</button>
</mat-dialog-actions>
